// extracted by mini-css-extract-plugin
export var actionButton = "_nk-0";
export var actionMenuContainer = "_nk-i";
export var bubble = "_nk-2";
export var bubbleActionMenu = "_nk-j";
export var bubbleContext = "_nk-6";
export var bubbleItems = "_nk-7";
export var customer = "_nk-3";
export var divider = "_nk-8";
export var fileList = "_nk-9";
export var hiddenComment = "_nk-o";
export var infoAbove = "_nk-a";
export var internal = "_nk-4";
export var lightActionButton = "_nk-1";
export var link = "_nk-b";
export var merchant = "_nk-5";
export var message = "_nk-c";
export var profilePicture = "_nk-e";
export var quillToolbarContainer = "_nk-f";
export var senderDate = "_nk-g";
export var senderDateCustomer = "_nk-h";
export var senderName = "_nk-d";
export var time = "_nk-k";
export var uploadedImage = "_nk-l";
export var username = "_nk-m";
export var xsmall = "_nk-n";